<script lang="ts">
	import LabelledInput from "./LabelledInput.svelte";
	import translations from "./ContactFields.translations.json";
	import { getTranslate } from "../../utils/getTranslate.js";
	import { emailRegex } from "../../../../core/utils/emailRegex.js";
	import { phoneRegex } from "../../../../core/utils/phoneRegex.js";

	export let idPrefix = "";
	export let nameClass = "border-b";
	export let textareaClass = "h-64";

	const translate = getTranslate(translations);
</script>

<div class="grid w-full items-end">
	<LabelledInput
		class="border-lttertiary {nameClass} [&_.input]:!px-8 [&_.label]:!left-8"
		id="{idPrefix}name"
		name="name"
		required
		autocomplete="given-name"
	>
		{translate("name")}
	</LabelledInput>
	<LabelledInput
		class="border-lttertiary border-b [&_.input]:!px-8 [&_.label]:!left-8"
		id="{idPrefix}phoneNumber"
		name="phoneNumber"
		required
		type="tel"
		autocomplete="tel"
		inputProps={{ pattern: phoneRegex.source }}
	>
		{translate("phone")}
	</LabelledInput>
	<LabelledInput
		class="border-lttertiary border-b [&_.input]:!px-8 [&_.label]:!left-8"
		id="{idPrefix}email"
		name="email"
		required
		type="email"
		autocomplete="email"
		inputProps={{ pattern: emailRegex.source }}
	>
		{translate("email")}
	</LabelledInput>
</div>
<div class="relative w-full">
	<textarea
		id="{idPrefix}message"
		name="message"
		class="input-with-label border-lttertiary peer w-full resize-none border-b px-8 !pb-4 !pt-8 text-xs focus:font-semibold focus:outline-none {textareaClass}"
		placeholder=" "
		required
		minlength={10}
	></textarea>
	<label class="label textarea-label !left-8" for="{idPrefix}message">{translate("yourMessage")}</label>
</div>
